var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-loader",class:_vm.className},[_c('section',{staticClass:"video-container"},[_c('video',{ref:"video",attrs:{"src":require("@/Asset/video/general/wordmark.webm"),"loop":"","muted":"","playsinline":""},domProps:{"muted":true}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }